module.exports = __webpack_public_path__ + "img/logo.20355ba8.png";